import Api from '.';

/**
 * Login the user with email and password.
 * @param {String} email The email.
 * @param {String} password The password.
 */
export function login(email, password) {
  const data = {
    email,
    password
  };
  return Api.post('/auth/login', data, false);
}

/**
 * Sends a token and get the logged user.
 * @param {String} email The email.
 * @param {String} password The password.
 */
export function loginWithToken(token) {
  const data = {
    token
  };
  return Api.post('/auth/me', data);
}
